export default "__VITE_ASSET__D1mhXdhB__"